<template>
    <b-form @submit.prevent="validateForm()"
            data-vv-scope="converter"
    >
        <div class="mb-1">
            <label class="mb-0">Valor:</label>
            <el-input id="input_value"
                      name="input_value"
                      type="number"
                      size="small"
                      v-model="input_value"
                      v-validate="'numeric|min_value:-1000000|max:1000000'"
                      data-vv-as=" "

            />
            <span class="text-danger span-error small"
                  v-text="errors.first('converter.input_value')"
            />
        </div>

        <div class="mb-1">
            <label class="mb-0">Unidad de origen:</label>
            <el-select id="source_unit"
                       name="source_unit"
                       size="small"
                       v-model="source_unit"
                       v-if="conversion_type"
            >
                <el-option v-for="unit in unitsMap[conversion_type].units"
                           v-if="unit !== target_unit"
                           :key="unit"
                           :value="unit"
                           v-validate="'required'"
                           data-vv-as=" "
                >
                    {{ unit }}
                </el-option>
            </el-select>
            <span class="text-danger span-error small"
                  v-text="errors.first('converter.source_unit')"
            />
        </div>

        <div class="mb-2">
            <label class="mb-0">Unidad de destino:</label>
            <el-select size="small"
                       v-model="target_unit"
                       disabled
                       v-if="conversion_type"
            >
                <el-option v-for="unit in unitsMap[conversion_type].units"
                           :key="unit"
                           :value="unit"
                >
                    {{ unit }}
                </el-option>
            </el-select>
        </div>

        <div class="alert alert-info">
            Resultado: {{ result }} {{ target_unit }}
        </div>

        <div class="mb-1 text-center">
            <hr>
            <b-btn variant="primary"
                   size="sm"
                   @click="validateForm()"
                   :disabled="!source_unit"
            >
                <i class="fa fa-check"></i> Aceptar
            </b-btn>
        </div>
    </b-form>
</template>

<script>

import {mapState, mapMutations} from 'vuex';

export default {
    name: 'unit_converter',
    props: {
        target_unit: {
            type: String

        },
        conversion_type: {
            type: String
        }
    },
    data() {
        return {
            unitsMap: {
                viscosidadCinematica: {
                    name: 'Viscosidad Cinemática',
                    units: ['mm²/s', 'cSt', 'St']
                },
                viscosidadDinamica: {
                    name: 'Viscosidad Dinámica',
                    units: ['mPa·s', 'cP', 'Pa·s', 'P']
                },
                presion: {
                    name: 'Presión',
                    units: ['hPa', 'atm', 'psi', 'mmHg', 'bar']
                },
                densidad: {
                    name: 'Densidad',
                    units: ['g/cm³', 'kg/m³', 'lb/ft³']
                },
                temperatura: {
                    name: 'Temperatura',
                    units: ['°C', 'K', '°F']
                }
            },
            source_unit: '',
            input_value: 0,
            conversions: {
                viscosidadCinematica: {
                    'mm²/s': 1,
                    'cSt': 1,
                    'St': 0.01
                },
                viscosidadDinamica: {
                    'mPa·s': 1,
                    'cP': 1,
                    'Pa·s': 0.001,
                    'P': 0.01
                },
                presion: {
                    'hPa': 1,
                    'atm': 0.000986923,
                    'psi': 0.0145038,
                    'mmHg': 0.750062,
                    'bar': 0.001
                },
                densidad: {
                    'g/cm³': 1,
                    'kg/m³': 1000,
                    'lb/ft³': 62.4280
                }
            }
        };
    },
    computed: {
        ...mapState('calculator', ['modal_converter']),
        result() {
            if (!this.source_unit) return 0;
            const converted = this.convert(parseFloat(this.input_value), this.source_unit, this.target_unit);
            return Number(converted.toFixed(4));
        }
    },
    methods: {
        ...mapMutations('calculator', ['setShowToModalConverter']),
        init() {
            this.input_value = 0;
            this.source_unit = '';
        },
        async validateForm() {
            setTimeout(() => {
                this.$validator.validateAll('converter')
                    .then(async (result) => {
                        if (result) {
                            const final_result = this.result;
                            this.setShowToModalConverter(false);
                            this.$emit('setValue', final_result.toString());
                        }
                    });
            });
        },
        convertTemperature(value, from, to) {
            let kelvin;
            if (from === '°C') kelvin = value + 273.15;
            else if (from === '°F') kelvin = (value + 459.67) * 5 / 9;
            else kelvin = value;

            if (to === '°C') return kelvin - 273.15;
            if (to === '°F') return kelvin * 9 / 5 - 459.67;
            return kelvin;
        },
        convert(value, from, to) {
            if (this.conversion_type === 'temperatura') {
                return this.convertTemperature(value, from, to);
            }

            const conversionRates = this.conversions[this.conversion_type];
            const baseValue = value / conversionRates[from];
            return baseValue * conversionRates[to];
        }
    }
};
</script>
